import { makeStyles } from 'tss-react/mui';

export default makeStyles()(theme => ({
    icon: {    
        display: 'flex',
        fontSize: theme.spacing(3),
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center'
    },
    screen: {
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        position: 'fixed',
        backgroundColor: ({ alpha = 0.35 }) => `rgba(0, 0, 0, ${alpha})`,
        alignItems: 'center',
        zIndex: '10000001'
    },
    message: {
        marginTop: theme.spacing(2)
    }
}));